// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.over_all_fees_wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.fees_wrapper {
    display: flex;
    flex-direction: column;
    width: 25%;
}

.fees_btn_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
}

.fees_wrapper input,.fees_wrapper select {
    border-color: #f3f3f3;
}

.over_all_fees_wrapper table tbody tr  .status_active{
    /* color: #6dff84; */
    color: #05bbc9;
}

.over_all_fees_wrapper table tbody tr .status_inactive{
    color: #ff9393;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SettingsPage/FessPage/FeesPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".over_all_fees_wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.fees_wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 25%;\n}\n\n.fees_btn_wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n}\n\n.fees_wrapper input,.fees_wrapper select {\n    border-color: #f3f3f3;\n}\n\n.over_all_fees_wrapper table tbody tr  .status_active{\n    /* color: #6dff84; */\n    color: #05bbc9;\n}\n\n.over_all_fees_wrapper table tbody tr .status_inactive{\n    color: #ff9393;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
